<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <g id="Pinterest">
      <g id="Icon-6" data-name="Icon">
        <path
          d="M19.024,4.976A9.933,9.933,0,0,0,4.976,19.024,9.933,9.933,0,0,0,19.024,4.976Zm-.707,13.341A8.877,8.877,0,0,1,12,20.933a9.022,9.022,0,0,1-1.791-.18.915.915,0,0,0,.034-.092l.61-3.44a4.917,4.917,0,0,0,2.29.63h.03a4.537,4.537,0,0,0,3.26-1.46,6.717,6.717,0,0,0,1.23-7.17,5.852,5.852,0,0,0-5.67-3.66h-.01a6.2,6.2,0,0,0-5.41,2.76,6.284,6.284,0,0,0-.54,5.83,1,1,0,1,0,1.83-.81,4.281,4.281,0,0,1,.39-3.93,4.171,4.171,0,0,1,3.73-1.85h.01a3.867,3.867,0,0,1,3.82,2.42,4.8,4.8,0,0,1-.79,4.99,2.6,2.6,0,0,1-1.85.88h-.01a3.112,3.112,0,0,1-1.668-.564.5.5,0,0,1-.217-.507L12,10.661a.994.994,0,0,0-.81-1.16,1,1,0,0,0-1.16.81L8.307,20.129a8.93,8.93,0,1,1,10.01-1.812Z"
        />
      </g>
    </g>
  </svg>
</template>
